import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { AimOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import AudienceAgency from './Agency/Agency';
import AudienceClients from './Clients/Clients';

const { Title } = Typography;

const Audience = () => {
  const [activeTab, setActiveTab] = useState('agency');

  const items = [
    {
      key: 'agency',
      label: (
        <span>
          <AimOutlined /> Audience Database
        </span>
      ),
      children: <AudienceAgency />
    },
    {
      key: 'clients',
      label: (
        <span>
          <UsergroupAddOutlined /> Client-Specific Audiences
        </span>
      ),
      children: <AudienceClients />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Audience & Targeting</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Audience;
